import React, { useState, useEffect, useMemo } from 'react';
import { TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { useController, useForm, useWatch } from 'react-hook-form';
import { FooterButtons, TabsSelector } from '../NewGuestPassModal';
import Input from '../../../../../components/Forms/Input';


const providerTypes = [
  {key: 'gas', name: "Gas"},
  {key: 'gardener', name: "Jardinería"},
  {key: 'moving_company', name: "Mudanza"},
  {key: 'water', name: "Agua"},
  {key: 'pets', name: "Mascotas"},
  {key: 'cleaning', name: "Limpieza"},
  {key: 'other', name: "Otro"},
]

function ProviderSelector({onChange, selected}){

  return (
    <View style={tw`row flex-wrap gap-x-4 gap-y-4`}>
      {
        providerTypes.map(provider =>
          <TouchableOpacity
            style={tw.style(`bg-white rounded-full px-5 py-2`, selected == provider.key && `bg-primary-800`)}
            onPress={() => onChange(provider)}
            key={provider.key}
          >
            <Text
              style={tw.style(`text-lg text-secondary font-500`, selected == provider.key && `text-white`)}
              >{provider.name}</Text>
          </TouchableOpacity>  
        )
      }
    </View>
  )
}


export default function ProviderTypeStep({ control, name, setValue, onNextPressed, onBackPressed }) {
  const { field, fieldState: { invalid, isTouched, isDirty, error }, formState } = useController({
    control,
    name,
    rules: { required: true }
  })

  const providerTypeName = useWatch({
    control,
    name: "guest_name",
  })

  useEffect(() => {
    // if(field.value ==)
  }, [field.value]);

  return (
    <>
      <View style={tw`flex-1`}>
        <Text style={tw`text-white text-center text-xl font-500 mb-8`}>Describe tu proveedor</Text>

        <ProviderSelector
          onChange={provider => {
            field.onChange(provider.key)
            if(provider.key !== 'other'){
              setValue('guest_name', provider.name)
            }else{
              setValue('guest_name', null)
            }
          }}
          selected={field.value}
        />

        {
          field.value == "other" &&
            <Input
              control={control}
              name='guest_name'
              rules={{ required: true }}
              style={{ subcontainer: `bg-white`, container: tw`mt-10` }}
              placeholder='Describe tu proveedor'
            />
        }
      </View>

      <FooterButtons
        onBackPressed={onBackPressed}
        onNextPressed={onNextPressed}
        nextDisabled={!field.value || (field.value == "other" && !providerTypeName)}
      />
    </>
  )
}